"use strict";
var thumbsEl = document.querySelector("#thumbs");
var largeImgEl = document.querySelector("#largeImg");
thumbsEl.addEventListener("click", function(ev) {
    ev.preventDefault();
    if (ev.target.tagName === "A") largeImgEl.src = ev.target.href;
    if (ev.target.tagName === "IMG") largeImgEl.src = ev.target.parentElement.href;
    if (ev.target.tagName === "LI") largeImgEl.src = ev.target.querySelector("a").href;
});

//# sourceMappingURL=index.31531a42.js.map
